import React, { PureComponent } from 'react'
import classnames from 'classnames'
import PlayerProgress from './progress/PlayerProgress'
import PlayerPlayheadTime from './time/PlayerPlayheadTime'
import PlayerFullscreen from './fullscreen/PlayerFullscreen'
import MiniPlay from './miniplay/MiniPlay'
import PlayerFooter from './footer/PlayerFooter'
import PlayerPlayToggle from './play/PlayerPlayToggle'
import PlayerBuffering from './buffering/PlayerBuffering'
import PlayerVolume from './volume/PlayerVolume'

export default class PlayerControls extends PureComponent {

	constructor(props) {
		
		super(props)
		this.state = { scrubbing: false }
		
		this.onClick = this.onClick.bind(this)
		this.onScrubb = this.onScrubb.bind(this)
		
	}

	componentWillUnmount() {
		
		clearTimeout(this.clickTimeout)
		this.clickTimeout = null;
		
	}
	
	onScrubb(value) {
		this.setState({
			scrubbing: value
		})
	}

	onClick() {
		
		if (this.clickTimeout) {
			
			clearTimeout(this.clickTimeout)
			this.clickTimeout = null;
			this.props.handleVideoDoubleClick()
			
		} else {
			
			this.clickTimeout = setTimeout(() => {
				
				this.props.handlePlayClick()
				this.clickTimeout = null;
				
			}, 250)
		}
		
	}

	render() {
		
		const { time, duration } = this.props 
		
		const className = classnames('player-controls', {
			'player-ctrl--scrubbing': this.state.scrubbing
		})
		
		const controls = this.props.minimal ? null : (
			<div className="hide-inactive">
				
				<PlayerFooter />
				
				<div className="player-controls__row">
					<div className="player-ctrl player-ctrl--play">
						<MiniPlay 
							onClick={ this.onClick }
							isPlaying={ this.props.isPlaying }
						/>
					</div>
					
					<div className="player-ctrl player-ctrl--progress">
						<PlayerProgress 
							buffered={ this.props.buffered }
							progress={ this.props.progress }
						/>
						<PlayerPlayheadTime 
							onSeek={ this.props.onSeek }
							onScrubb={ this.onScrubb }
							time={ time } 
							duration={ duration }
						/>
					</div>
					
					<div className="player-ctrl player-ctrl--volume">
						<PlayerVolume
							volume={ this.props.volume }
							handleVolumeUpdate={ this.props.handleVolumeUpdate }
						/>
					</div>
					
					<div className="player-ctrl player-ctrl--fullscreen">
						<PlayerFullscreen 
							onClick={ this.props.handleFullscreenClick }
						/>
					</div>
					
				</div>
			</div>
		)
		
		return (
			<div className={ className }>
				
				<div className="hit-area" onClick={this.onClick} />
				
				<PlayerPlayToggle 
					onClick={ this.onClick } 
					isPlaying={ this.props.isPlaying }
					isInitiated={ this.props.isInitiated }
					/>
					
				<PlayerBuffering 
					isBuffering={ this.props.isBuffering }
					/>
				{ controls }
				
				
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/player/controls/PlayerControls.jsx